// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3318":"72d9faf0edac6e42","3501":"183d28f05d4bd29d"}[chunkId] + ".js";
};